// DESIGN SYSTEM TYPES
export type Type = 'contained' | 'outlined' | 'null';

// DESIGN SYSTEM CONSTANTS
export const [CONTAINED, OUTLINED, TEXT] = ['contained', 'outlined', 'null'];

export default [CONTAINED, OUTLINED, TEXT];
